
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/proptrading/arena/newbie",
      function () {
        return require("private-next-pages/proptrading/arena/newbie/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/proptrading/arena/newbie"])
      });
    }
  